import React from 'react';
import { DateTime } from 'luxon';

class ProductIDCellComponent extends React.Component {

  render() {
    const { value } = this.props;
    return (value || '').toString().replace(/^com\.rewards(?:inc)?:/i, '')
  }

}

export default ProductIDCellComponent;


// WEBPACK FOOTER //
// ./src/views/common/product-id-cell.js